import { browserAllowed } from './modules/browser';
import HitSender from './modules/HitSender';
import { hasMessage, storeMessage } from './modules/storage';
/**
 * Parse stack trace lines - store mentioned "/[name].js" files
 */
export const _parseStackLines = (stack) => {
    return typeof stack === 'string'
        ? stack
            .split('\n')
            .map((stackLine) => {
            return stackLine.match(new RegExp('/[a-zA-Z0-9_\\.-]+\\.js(\\?szn_loader=1)?', 'gi'));
        })
            .filter(Boolean)
        : [];
};
/**
 * Handler error - parse stack - validate - send
 */
export const _errorHandler = (errorEvent, configuration) => {
    const { error } = errorEvent;
    if (!error || !error.stack || !error.message) {
        return;
    }
    const { message, stack } = error;
    const { scriptName, baseUrl, endpoint } = configuration;
    // every script can log any error only once
    const storageMessage = `${scriptName}-${message}`;
    if (hasMessage(storageMessage)) {
        // This error has already been sent
        return;
    }
    const stackLinesParsed = _parseStackLines(stack);
    const linesLimit = 3;
    const scriptsMentionedFlat = stackLinesParsed.splice(0, linesLimit).reduce((acc, item) => {
        return (acc = [...acc, ...item]);
    }, []);
    if (scriptsMentionedFlat.find((script) => {
        return (~script.indexOf(`/${scriptName}`) &&
            // if loader redirect -> do not catch "real" loaded lib
            (endpoint !== 'loader-script' || !~script.indexOf('szn_loader=1')));
    })) {
        new HitSender(endpoint, baseUrl)
            .appendValue('msg', message)
            .appendValue('script', scriptName)
            .appendValue('href', window.location.href)
            .appendValue('referrer', document.referrer)
            .appendValue('stack', stack)
            .send();
        storeMessage(storageMessage);
    }
};
/**
 * Attach error listener (only once for each script)
 */
export const startErrorHandling = (config) => {
    const { scriptName } = config;
    const initMessage = `${scriptName}-init`;
    if (hasMessage(initMessage)) {
        // Prevent multiple listeners in SPA
        return;
    }
    if (!browserAllowed(window.navigator.userAgent)) {
        // browser blacklist check
        return;
    }
    storeMessage(initMessage);
    window.addEventListener('error', (errorEvent) => _errorHandler(errorEvent, config));
};
